import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import PaymentMethods from './PaymentMethods';
import Transactions from './Transactions';
import Subscription from './Subscription';
import useOrgStore from '../../../../store/zustand/useOrgStore';

const Billing: React.FC = () => {
  const [tab, setTab] = useState(0);
  const orgData = useOrgStore((state) => state.orgData);
  const isSeatBased = orgData?.billingType === 'seat_based';

  return (
    <Box sx={{ width: '100%', height: '100%', p: 3 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>
          Billing
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage payment methods, view transactions
          {isSeatBased ? ', and manage your subscription' : ''}.
        </Typography>
      </Box>

      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }}>
        <Tab label="Payment Methods" />
        <Tab label="Transactions" />
        {isSeatBased && <Tab label="Subscription" />}
      </Tabs>

      {tab === 0 && <PaymentMethods />}
      {tab === 1 && <Transactions />}
      {isSeatBased && tab === 2 && <Subscription />}
    </Box>
  );
};

export default Billing;
